import { useTranslation } from 'react-i18next';

import { SummaryInformation, TSummaryInformation } from '@/ui-kit/SummaryInformation/SummaryInformation';

import { KycInformationSection } from '@/features/kyc/components/userInformation/InformationSection';
import { TPhysicalSectionKey } from '@/features/kyc/store/types/physical.types';

import { IUser } from '@/features/user/store/user.model';

import { usePhysicalUserVerificationProps } from '@/features/kyc/hooks/usePhysicalUserVerificationProps';
import { TaxResidences } from '@/features/taxResidences/components/TaxResidences';

interface IVerificationDetail {
  user: IUser;
  isSectionOnEdition: (key: TPhysicalSectionKey) => boolean;
  isSectionEditable: (key: TPhysicalSectionKey) => boolean;
  toogleSectionEditMode: (key: TPhysicalSectionKey) => void;
}

export function PhysicalVerificationDetail({
  user,
  isSectionOnEdition,
  isSectionEditable,
  toogleSectionEditMode,
}: IVerificationDetail) {
  const { t } = useTranslation();

  const isBirthAndNationalityOnEdition = isSectionOnEdition('birthAndNationality');
  const isSituationOnEdition = isSectionOnEdition('situation');

  const { isBirthAndNationalityInvalid, birthNationality, situation, isLoading, onUpdateUser, onCancelEdition } =
    usePhysicalUserVerificationProps({
      user,
      isBirthAndNationalityOnEdition,
      isSituationOnEdition,
    });

  const userVerification: TSummaryInformation = {
    title: t('pages.dashboard.createUser.form.pages.verificationDetails'),
    sections: [
      {
        component: (
          <KycInformationSection
            section={birthNationality}
            isOnEdition={isBirthAndNationalityOnEdition}
            sectionKey="birth-nationality"
            isLoading={isLoading}
            isFormInvalid={isBirthAndNationalityInvalid}
            isSectionNotEditable={isSectionEditable('birthAndNationality')}
            onEdit={() => toogleSectionEditMode('birthAndNationality')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('birthAndNationality'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('birthAndNationality'))}
          />
        ),
      },
      {
        component: (
          <KycInformationSection
            section={situation}
            isOnEdition={isSituationOnEdition}
            sectionKey="situation"
            isLoading={isLoading}
            isSectionNotEditable={isSectionEditable('situation')}
            onEdit={() => toogleSectionEditMode('situation')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('situation'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('situation'))}
          />
        ),
      },
      {
        component: (
          <TaxResidences
            user={user}
            isSectionOnEdition={isSectionOnEdition('taxResidence')}
            isSectionEditable={isSectionEditable('taxResidence')}
            toogleSectionEditMode={() => toogleSectionEditMode('taxResidence')}
          />
        ),
      },
    ],
  };

  return <SummaryInformation {...userVerification} key="userVerification" />;
}
